import MainService from "@/services/MainService.js";
import Vue from "vue";
import VueAxios from "vue-axios";
import axios from "axios";
import msal from "vue-msal";

Vue.use(VueAxios, axios);

Vue.use(msal, {
  auth: {
    clientId: process.env.VUE_APP_MSAL_CLIENT_ID,
    tenantId: process.env.VUE_APP_MSAL_TENANT_ID,
    redirectUri: process.env.VUE_APP_MSAL_REDIRECT_URI,
  },
});

export default {
  name: "LoginPage",
  data() {
    let ss = new MainService();
    return {
      ss: ss,
      loginRequest: {
          email: '',
          password: ''
      },
      errorBag: {
          email: '',
          password: ''
      },
      imgLogo: {
        type: String,
        default: require("@/assets/img/imgmenu.png"),
      },
      isSubmitting: false,  // Controlar si el botón fue presionado
      showError: false      // Controlar si el cuadro de error se muestra
    };
  },
  props: {
    msg: String,
  },
  methods: {
    // login(){
    //     this.$router.push('/dashboard');

    // }
    login() {
      this.isSubmitting = true;  // Marcar que el botón fue presionado
      this.showError = false;    // Ocultar cualquier error previo
      this.errorBag.password = '';  // Limpiar errores previos

      this.ss
        .login(this.loginRequest)
        .then((result) => {
          localStorage.setItem("persona", JSON.stringify(result.data.data));
          localStorage.setItem("token", JSON.stringify(result.data.token));
          this.$router.push("/dashboard");
          // this.$router.go();
        })
        .catch((error) => {
          this.showError = true;  // Mostrar el cuadro de error

          if (error.response && error.response.status === 401) {
              this.errorBag.password = "Token incorrecto. Por favor, inténtelo nuevamente.";
          } else if (error.response && error.response.data && error.response.data.errors) {
              if (error.response.data.errors.password) {
                  const errorMsg = error.response.data.errors.password[0].replace('password', 'token');
                  this.errorBag.password = errorMsg;
              }
          } else {
              this.errorBag.password = "Ocurrió un error inesperado. Intente más tarde.";
          }
      });
    },
    authenticate() {
      if (!this.$msal.isAuthenticated()) {
        this.$msal.signIn();
      }
    },

    // Método para obtener cookies
    getCookie(name) {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? match[2] : null;
    }
  },
  mounted() {
    var persona = JSON.parse(localStorage.getItem("persona"));

// Verificamos la cookie desde el montaje del componente raíz
    if (this.getCookie('clearLocalStorageIngles') === 'true') {
      // Limpiamos el localStorage
      localStorage.clear();
      const email = this.getCookie('userEmail');
      
      // Opcional: Eliminamos la cookie para que no persista más de una vez
      document.cookie = "clearLocalStorageIngles=; path=/; domain=.emi.edu.bo; expires=Thu, 01 Jan 1970 00:00:00 GMT";
      
      // Redirigimos al login o página de inicio
      this.$router.push('/login?email='+email);
      //window.close();
    }

    const email = this.$route.query.email;
                const password = this.$route.query.password;
				this.loginRequest.email=email

                if(email && password) {
                        this.loginRequest.email=email
                        this.loginRequest.password=password
                        this.login();
                }
                else {
    if (persona) {
      localStorage.clear();
    }
    if (this.$msal.isAuthenticated()) {
      let loginTokenRequest = {
        token: this.$msal.data.user.accountIdentifier,
        email: this.$msal.data.user.userName,
      };
      this.ss
        .loginToken365(loginTokenRequest)
        .then((result) => {
          localStorage.setItem("persona", JSON.stringify(result.data.data));
          localStorage.setItem("token", JSON.stringify(result.data.token));
          this.$router.push("/dashboard");
          // this.$router.go();
        })
        .catch((error) => {
          this.errorBag = error.response.data.errors;
          this.$bvToast.toast("Problema al Iniciar Sesion", {
            title: "Error",
            variant: "danger",
            autoHideDelay: 5000,
          });
          this.$msal.signOut();
        });
      } else {
      }
    }
  },
};
